<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">Шаблоны протоколов</h2>
      <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 20%;">Наименования</th>
                <th style="width: 10%;">Версия</th>
                <th style="width: 15%;">Категория</th>
                <th style="width: 15%;">Переменные</th>
                <th style="width: 20%;">Описание</th>
                <th style="width: 15%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="templates.length > 0">
                <tr v-for="(template, index) in templates">
                  <td>{{index + 1}}</td>
                  <td>
                    <p><b>Файл:</b> {{template.name}}</p>
                    <p><b>ПО:</b> {{template.po}}</p>
                  </td>
                  <td>{{template.version}}</td>
                  <td>
                    <p class="mb-0" v-if="template.category">
                      <span v-if="template.category.parent">{{template.category.parent.name}} -> </span>
                      {{template.category.name}}
                    </p>
                  </td>
                  <td>
                    <template v-for="(tag, index) in template.fields">
                      <span class="badge" :class="{'bg-primary': index % 2 === 0, 'bg-secondary': index % 2 !== 0 }" style="margin-bottom:5px;">{{tag}}</span><br>
                    </template>
                  </td>
                  <td>{{template.description}}</td>
                  <td>
                    <div class="btn-group">
                      <a class="btn btn-sm btn-success" @click.prevent="downloadRecord(template.id)" href="#"><font-awesome-icon icon="fas fa-download" /></a>
                      <a class="btn btn-sm btn-primary" @click.prevent="editRecord(template)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                      <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(template.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="4">
                    Нет данных для отображения
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Наименование файла</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование файла" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Версия</label>
                <input v-model="recordform.version" type="text" placeholder="Версия" class="form-control">
              </div>
              <div class="form-group">
                <label>Наименование ПО</label>
                <input v-model="recordform.po" type="text" placeholder="Наименование ПО" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Выберите категорию</label>
                <treeselect v-model="recordform.category_id" :multiple="false" :defaultExpandLevel="1" :options="categories">
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                    {{ node.raw.name }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>

                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </div>
              <div class="form-group">
                <label>Описание</label>
                <input v-model="recordform.description" type="text" placeholder="Описание" class="form-control">
              </div>
              <label>Файл</label>
              <div class="input-group" v-if="changefile">
                <input type="file" :key="fileInputKey" @change="fileUpload" accept=".html,.docx,.xml"  class="form-control" style="border: 0;" />
                <div v-if="changefile && editmode" class="input-group-append">
                  <button @click="changefile = !changefile" class="btn btn-outline-primary waves-effect" type="button">Отмена</button>
                </div>
              </div>
              <div class="input-group" v-if="editmode && !changefile">
                <input v-model="recordform.file" disabled type="text" name="number" class="form-control">
                <div v-if="!changefile" class="input-group-append">
                  <button @click="changefile = !changefile" class="btn btn-outline-primary waves-effect" type="button"><font-awesome-icon icon="fas fa-edit" /></button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
            <div v-if="find_tags.length > 0" class="modal-body">
              <h5>Найденные переменные:</h5>
              <template v-for="(tag, index) in find_tags">
                <span class="badge" :class="{'bg-primary': index % 2 === 0, 'bg-secondary': index % 2 !== 0 }" style="margin-bottom:5px;">{{tag}}</span><br>
              </template>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Modal Show Result -->
    <div class="modal modal-slide-in fade" id="showPDFModal" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
      <div class="modal-dialog modal-x" role="document">
        <div class="modal-content p-0">
          <embed :src="'/pdf/template/'+link" class="h-100 w-100" type='application/pdf'>
        </div>
      </div>
    </div>
    <!-- !Modal Show Result -->

  </div>
</template>

<script>
  // import the component
  import Treeselect from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: { Treeselect },
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      }
    },
    data () {
      return {
        find_tags: [],
        categories: [],
        link: null,
        fileInputKey: 0,
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 50,
        perPageList: [10, 25, 50, 100],
        templates: [],
        recordform: new Form({
          id: null,
          name: null,
          description: null,
          file: null,
          category_id: null,
          version: null,
          po: null
        }),
        editmode: false,
        changefile: false
      }
    },
    methods: {
      downloadRecord(id){
        window.open('/protocol_template/'+id+'/download','_blank');
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      editRecord(record){
        this.editmode = true;
        this.changefile = false;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.name = record.name;
        this.recordform.version = record.version;
        this.recordform.po = record.po;
        this.recordform.category_id = record.category_id;
        this.recordform.description = record.description;
        this.recordform.file = record.file;
        this.find_tags = record.fields;
        $('#addNewRecord').modal('show');
      },
      fileUpload(e){
        this.find_tags.splice(0);
        this.recordform.file = e.target.files[0];
        const data = new FormData();
        data.append('file', this.recordform.file);
        axios.post('/api/protocol/template_file', data)
        .then((response)=>{
          this.find_tags = response.data;
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      newRecord(){
        this.editmode = false;
        this.changefile = true;
        this.recordform.reset();
        $('#addNewRecord').modal('show');
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadRecords();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadRecords();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadRecords();
        }
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadRecords();
          this.$Progress.finish();
        }, 500);

      },
      changePerPage(){
        this.currentPage = 1;
        this.loadRecords();
      },
      createRecord(){
        this.$Progress.start();
        const data = new FormData();
        data.append('name', this.recordform.name);
        data.append('version', this.recordform.version);
        data.append('po', this.recordform.po);
        data.append('category_id', this.recordform.category_id);
        data.append('description', this.recordform.description);
        data.append('file', this.recordform.file);
        data.append('fields', JSON.stringify(this.find_tags));
        axios.post('/api/protocol/templates', data)
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.fileInputKey++;
          this.find_tags.splice(0);
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        const data = new FormData();
        data.append('name', this.recordform.name);
        data.append('version', this.recordform.version);
        data.append('po', this.recordform.po);
        data.append('category_id', this.recordform.category_id);
        data.append('description', this.recordform.description);
        data.append('fields', JSON.stringify(this.find_tags));
        data.append('file', this.recordform.file);
        data.append("_method", "put");
        axios.post('/api/protocol/templates/'+this.recordform.id, data)
        .then((response) => {
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.find_tags.splice(0);
          this.fileInputKey++;
          this.editmode = false;
          this.changefile = false;
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
            this.recordform.delete('/api/protocol/templates/'+id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadCategories(){
        axios.get('/api/protocol/template_category').then(({ data }) => {
          this.categories = data;
        });
      },
      loadRecords(){
        axios.get('/api/protocol/templates?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.templates = data.data;
          this.lastPage = data.last_page;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.loadCategories();
      this.$Progress.finish();
    }
  }
</script>
